import React, { useState } from 'react';
import TopBar from './components/TopBar';
import NavTabs from './components/NavTabs';
import Catalogo from './components/Catalogo';
import Pedidos from './components/Pedidos';
import Inventario from './components/Inventario';
import Stats from './components/Stats';
import ConfigEnvio from './components/ConfigEnvio';
import ConfigVariantes from './components/ConfigVariantes';

function App() {
  const [tabActiva,     setTabActiva]     = useState('stats');
  const [filtroPedidos, setFiltroPedidos] = useState('todos');
  const [inventarioCambios, setInventarioCambios] = useState(false);

  function cambiarTab(tab) {
  if (tabActiva === 'inventario' && tab !== 'inventario' && inventarioCambios) {
    if (!window.confirm('Tienes cambios sin guardar en Inventario. ¿Seguro que quieres salir?')) return;
  }
  if (tab === 'pedidos') setFiltroPedidos('todos');
  if (tab !== 'inventario') setInventarioCambios(false);
  setTabActiva(tab);
  } 

  return (
    <div style={{ maxWidth: 430, margin: '0 auto', minHeight: '100vh', background: '#F0F4F0' }}>
      <TopBar />
      <NavTabs tabActiva={tabActiva} onCambiarTab={cambiarTab} />
      {tabActiva === 'catalogo'   && <Catalogo />}
      {tabActiva === 'pedidos'    && <Pedidos filtroInicial={filtroPedidos} />}
      {tabActiva === 'inventario' && <Inventario onCambiosChange={setInventarioCambios} />}
      {tabActiva === 'stats'      && <Stats onNavegar={(tab, filtro) => { setFiltroPedidos(filtro); setTabActiva(tab); }} />}
      {tabActiva === 'envio'      && <ConfigEnvio />}
      {tabActiva === 'variantes'  && <ConfigVariantes />}
    </div>
  );
}

export default App;